import React, { useEffect, useState } from "react";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import CircularProgress from "@mui/material/CircularProgress";
import { FiSearch } from "react-icons/fi";
import { CFormLabel } from "@coreui/react";
import { GET_API_CALL } from "../../utils/services";

export default function AddressAutocomplete({
  url,
  optionKeyToShow,
  name,
  placeHolder,
  label,
  value,
  setValue,
  disabled = false,
}) {
  const [search, setSearch] = useState("");
  const [open, setOpen] = useState(false);
  const [options, setOptions] = useState([]);
  const [filteredOptions, setFilteredOptions] = useState([]);
  const [loading, setLoading] = useState(false);

  // Fetch whenever `url` changes
  useEffect(() => {
    if (!url) {
      setOptions([]);
      setFilteredOptions([]);
      setSearch("");
      return;
    }
    fetchOptions();
  }, [url]);

  const fetchOptions = async () => {
    try {
      setLoading(true);
      await GET_API_CALL(url, "", (res) => {
        const dataArray = Array.isArray(res?.data)
          ? res.data
          : Object.values(res?.data || {});
        setOptions(dataArray);
        setFilteredOptions(dataArray);
        setLoading(false);
      });
    } catch (error) {
      console.error("Autocomplete fetch error:", error);
      setLoading(false);
    }
  };

  const handleInputChange = (_, newInputValue, reason) => {
    if (reason === "clear") {
      setSearch("");
      setFilteredOptions(options);
    } else {
      setSearch(newInputValue);
      const lowerSearch = newInputValue.toLowerCase();
      setFilteredOptions(
        options.filter((opt) =>
          (opt?.[optionKeyToShow] || "").toLowerCase().includes(lowerSearch)
        )
      );
    }
  };

  return (
    <div className="w-100 bg-white">
      {label && <CFormLabel className="lable-text">{label}</CFormLabel>}
      <Autocomplete
        size="small"
        open={open}
        fullWidth
        onOpen={() => setOpen(true)}
        onClose={() => setOpen(false)}
        isOptionEqualToValue={(option, val) => option?._id === val?._id}
        getOptionLabel={(option) => option?.[optionKeyToShow] || ""}
        options={filteredOptions}
        loading={loading}
        disabled={disabled}
        value={value}
        inputValue={search}
        onInputChange={handleInputChange}
        onChange={(_, newValue, reason) => {
          if (reason === "clear") {
            setValue(null);
            setSearch("");
            setFilteredOptions(options);
          } else {
            setValue(newValue);
          }
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            name={name}
            placeholder={placeHolder}
            sx={{
              "& .MuiOutlinedInput-root": { height: "38px" },
              "& .MuiInputBase-input": {
                padding: "8px 14px",
                fontSize: "14px",
              },
            }}
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <>
                  {loading && <CircularProgress color="error" size={20} />}
                  <FiSearch />
                  {params.InputProps.endAdornment}
                </>
              ),
            }}
          />
        )}
      />
    </div>
  );
}
